export default "__VITE_ASSET__DGROZwp$__"